// Custom modal zoomed image
const modalZoomedImg = () => {
    let modal = document.querySelectorAll('.js-modal-images');
    let imgModals = document.querySelectorAll('.custom-js-zoomed');

    if(imgModals){
        imgModals.forEach(img =>{
           img.addEventListener('click',function(e){
            let marker = e.currentTarget.getAttribute('data-modal');
            let targetModal = document.getElementById(marker);
            if(targetModal){
                var modalImg = targetModal.querySelector(".js-img-modal");
                targetModal.style.display = "block";
                modalImg.src = this.src;
            }
           });
        });
    }

    if(modal){
        modal.forEach(modal =>{
            let close = modal.querySelector('.js-close-modal-zoomed');
            if(close) close.addEventListener('click',() => modal.style.display = "none");
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
modalZoomedImg();
});